import { Col, Row } from "react-bootstrap";
import ConsultIcon from "../assets/img/ConsultIcon.png";
import IdentifyIcon from "../assets/img/IdentifyIcon.png";
import BookIcon from "../assets/img/BookIcon.png";
import TreatedIcon from "../assets/img/TreatedIcon.png";
import TreatmentIcon from "../assets/img/TreatmentIcon.png";

export const Process = () => {
  return (
    <section className="process" id="process">
      <Row style={{ marginRight: "0px" }}>
        <div className="processdiv">
          <h1>
            The{" "}
            <span style={{ color: "#306AFF" }}>
              <span className="pencilline3">Process</span>
            </span>
          </h1>
          <p>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusant ium doloremque laudantium, totam rem.
          </p>
        </div>
      </Row>

      <Row style={{ marginRight: "0px" }} className="align-items-center">
        <div className="processrow">
          {/* Consult */}
          <div className="processbox">
            <img className="processicon" src={ConsultIcon} alt="ConsultIcon" />
            <p>
              <span
                style={{
                  color: "#306AFF",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Consult
              </span>
            </p>
            <p>With our experts and discover various options available.</p>
          </div>
          {/* Identify */}
          <div className="processbox">
            <img
              className="processicon"
              src={IdentifyIcon}
              alt="IdentifyIcon"
            />
            <p>
              <span
                style={{
                  color: "#306AFF",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Identify
              </span>
            </p>
            <p>
              The perfect plan from our diverse range of options to suit your
              needs.
            </p>
          </div>
          {/* Book */}
          <div className="processbox">
            <img className="processicon" src={BookIcon} alt="BookIcon" />
            <p>
              <span
                style={{
                  color: "#306AFF",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Book
              </span>
            </p>
            <p>A plan and get it tailored exactly according to your needs.</p>
          </div>
          {/* Get Treated */}
          <div className="processbox">
            <img className="processicon" src={TreatedIcon} alt="TreatedIcon" />
            <p>
              <span
                style={{
                  color: "#306AFF",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Get Treated
              </span>
            </p>
            <p>
              At the facility of your choosing, by the doctor best suited for
              you.
            </p>
          </div>
          {/* Post Treatment */}
          <div className="processbox">
            <img
              className="processicon"
              src={TreatmentIcon}
              alt="TreatmentIcon"
            />
            <p>
              <span
                style={{
                  color: "#306AFF",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Post Treatment
              </span>
            </p>
            <p>We will always be there for you whenever you need us.</p>
          </div>
        </div>
        <Col xs={12} md={6} xl={2}></Col>
      </Row>
    </section>
  );
};
